import { isTrpcErrorCode, isUserFacingTrpcError } from '@algoacademy/backend/trpc/client-errors'

/**
 * A refused offer explains itself in one long sentence - which mentoring, which
 * cadence, which buyer, and the offer that already paid. Nobody reads that in
 * the five seconds a toast lives, so the same sentence also lands in a panel
 * that stays until the next attempt. Field-level complaints are excluded: the
 * form already shows those next to the inputs.
 */
export function readRefusal(error: unknown): string | null {
  if (!isUserFacingTrpcError(error) || isTrpcErrorCode(error, 'BAD_REQUEST')) {
    return null
  }

  return error.message
}
